// Das eine Tooltip-Element und seine Positionierung.
//
// `#tooltip` gehoerte bis hierher dem Panel, samt der Rechnung „einblenden,
// messen, an der Kante spiegeln, auf den Rand klemmen". Mit dem zweiten und
// dritten Nutzer — der Erzleiste im HUD und den Filterchips — waere daraus
// dreimal dieselbe Rechnung geworden, und die dritte Kopie haette am Rand
// etwas anderes getan als die erste.
//
// Der Inhalt bleibt dagegen beim Aufrufer: **was** im Tooltip steht, ist eine
// Frage der Sache (ein Baumknoten, ein Erz), **wo** er steht ist eine Frage des
// Bildschirms. Nur das Zweite liegt hier.
//
// Er haengt an keinem Panel und verschwindet deshalb nur, wenn ihn jemand
// abmeldet — wer ihn zeigt, sorgt fuer `hideTooltip()`.

const el = (): HTMLElement => {
  const found = document.getElementById('tooltip');
  if (!found) throw new Error('Tooltip-Element fehlt: tooltip');
  return found;
};

/** Der Abstand zum Zeiger und zum Bildschirmrand — in Bildpunkten. */
const OFFSET_X = 18;
const OFFSET_Y = 14;
const MARGIN = 8;
const MIN = 6;

/**
 * Den Tooltip mit diesem Inhalt an dieser Bildschirmposition zeigen.
 *
 * Erst einblenden, dann messen: ein verstecktes Element hat keine Groesse, und
 * ohne sie kann die Kantenspiegelung nicht rechnen.
 */
export function showTooltip(html: string, x: number, y: number): void {
  const tip = el();
  tip.innerHTML = html;
  tip.classList.remove('hidden');

  const rect = tip.getBoundingClientRect();
  let left = x + OFFSET_X;
  let top = y + OFFSET_Y;
  if (left + rect.width > innerWidth - MARGIN) left = x - rect.width - OFFSET_X + 4;
  if (top + rect.height > innerHeight - MARGIN) top = y - rect.height - OFFSET_Y + 4;
  tip.style.left = Math.max(MIN, left) + 'px';
  tip.style.top = Math.max(MIN, top) + 'px';
}

export function hideTooltip(): void {
  el().classList.add('hidden');
}
